<template>
  <div class="vue__form-wrapper">
    <div class="vue__form-container">
      <transition
        name="fade"
        mode="out-in"
      >
        <template v-if="loaded">
          <RegistrationClosed v-if="registrationClosed" />
          <component
            v-else-if="!submitted"
            :is="formComponent"
          />
          <RequestedPayment v-else-if="payment" />
          <SubmittedForm v-else />
        </template>
        <SimpleSpinner v-else />
      </transition>
    </div>
  </div>
</template>

<script>
  import EventForm from './components/EventForm';
  import CourseForm from './components/CourseForm';
  import WebinarForm from './components/WebinarForm';

  import SubmittedForm from './components/SubmittedForm';
  import RequestedPayment from './components/RequestedPayment';
  import RegistrationClosed from './components/RegistrationClosed';
  import CustomInterestForm from './components/CustomInterestForm';
  import SeminarForm from './components/SeminarForm';
  import ZoomWebinarForm from './components/ZoomWebinarForm';
  import CustomProductForm from './components/CustomProductForm';

  import { mapState } from 'vuex';

  export default {
    components: {
      SubmittedForm,
      RequestedPayment,
      RegistrationClosed,
    },

    computed: {
      ...mapState([
        'interestType',
        'loaded',
        'submitted',
        'payment',
        'registrationClosed',
      ]),

      formComponent () {
        switch (this.interestType) {
          case 'Webinar':
            return WebinarForm;
          case 'CoursePrefix':
            return CourseForm;
          case 'OfflineEvents::Event':
            return EventForm;
          case 'CustomInterest':
            return CustomInterestForm;
          case 'Webinars::Sets::Set':
            return SeminarForm;
          case 'Webinars::ZoomWebinar':
            return ZoomWebinarForm;
          case 'CustomProducts::CustomProduct':
            return CustomProductForm;
          default:
            throw new Error('unknown interest');
        }
      },
    },
  };
</script>

<style>
  .intl-tel-input {
    margin-bottom: 0;
  }

  .fade-slide-enter-active, .fade-slide-leave-active {
    transition: opacity .1s, transform .1s;
  }

  .fade-slide-enter, .fade-slide-leave-to {
    opacity: 0;
  }

  .fade-slide-enter {
    transform: translateY(-8px);
  }

  .fade-slide-leave-to {
    transform: translateY(8px);
  }

  .v-select#interest_id .dropdown-toggle {
    padding: 5px;
    border: 2px solid #ccc;
  }

  .text-nowrap {
    white-space: nowrap;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }
</style>

<style
  lang="scss"
  scoped
>
  .vue__form-wrapper {
    height: 100%;
    max-width: 600px;
    margin: 0 auto;
    padding: 1rem 2rem;

    ::v-deep label {
      font-weight: 500;
      margin-bottom: 0.3rem;
      display: block;
    }

    &, ::v-deep * {
      box-sizing: border-box;
    }

    &, ::v-deep input {
      font: 400 16px Roboto, Arial, Helvetica, sans-serif;
    }

    @media (max-width: 768px) {
      width: 100%;
      padding: 1rem .5rem;
    }

    .vue__form-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;

      @media (max-width: 768px) {
        width: auto;

        ::v-deep h2 {
          font-size: 1.6rem;
          overflow-wrap: break-word;
          word-wrap: break-word;
        }
      }

      form {
        width: 100%;
      }
    }
  }
</style>
